import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Grid, useTheme } from "@mui/material";

interface DeleteConfirmationDialogProps {
    entityName: string;
    onClose: () => void;
    onConfirm: () => void;
}

export default function DeleteConfirmationDialog(props: DeleteConfirmationDialogProps): JSX.Element {
    const theme = useTheme();

    return (
        <Dialog open>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6">
                        DELETING {props.entityName}
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <Grid item flex={1}>
                        <Typography textAlign={"center"} sx={{ p: 1 }}>
                            {`ARE YOU SURE YOU WANT TO DELETE THE ${props.entityName}?`}
                        </Typography>
                        <Typography textAlign={"center"} color={theme.palette.error.main} sx={{ p: 1, pb: 4 }}>
                            THIS ACTION CANNOT BE UNDONE!
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button variant="contained" sx={{ m: 1 }} onClick={props.onClose}>
                        CANCEL
                    </Button>
                    <Button variant="contained" color={"error"} sx={{ m: 1 }} onClick={props.onConfirm}>
                        DELETE
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
}
